const getInterviewStatus = (round) => ({
  "INTERVIEW COMPLETED": "Interview Completed",
  "INTERVIEW SCHEDULED": "Scheduled",
  "SEND_TO_HIRING_MANAGER": "Sent to Hiring Manager",
  "REJECT": `Rejected at R ${round}`,
  "DEMO SUBMITTED": "Demo Submitted",
  "NOTIFY_HR": "Notified HR",
  "ROUND ACCEPTED": `Accepted at R ${round}`,
  "INTERVIEW RESCHEDULED": "Rescheduled",
  "ONHOLD": "On Hold",
  "ACCEPT": "Accepted",
  "MAINS FAILED": "Mains Failed"
});

exports.interviewConstants = getInterviewStatus;
